// @ts-nocheck


import React, { Component } from 'react';
import notification from 'antd/lib/notification';
import { connect } from 'react-redux';
import { navigate } from '../../lib/routerAdapter';
import moment from 'moment';
import styled from 'styled-components';

import {
  cleanContractVehicle,
  updateContractVehicle,
  addContractVehicle,
  fetchContractVehicle } from
'./../../ducks/contractVehicle';

import InnerForm from './components/InnerForm';
import { Panel } from './../../components/layout';
import { formatDateTimeToISOString } from './../../lib/helpers';

import Breadcrumbs, { Crumb } from '../../components/layout/Breadcrumbs';
import { vehicleTypes, ownerTypes, vehicleStatusEnum } from '../../lib/enum';
import Header from '../../components/layout/Header';
import { notificationLoading } from './../../components/Notifications';

const StyledPanel = styled(Panel)`
  padding-top: 0;
`;













const initialContractVehicle = {
  vehicle: {}
};

class Form extends Component {
  async componentDidMount() {
    const { vehicleId } = this.props;
    this.props.cleanContractVehicle();
    if (vehicleId) {
      try {
        await this.props.fetchContractVehicle(vehicleId);
      } catch (error) {
        navigate('/vehicles/contract');
        notification.error({
          message: 'Ошибка',
          description: error.message
        });
      }
    }
  }

  formatDate = (value) => {
    return value ? moment.utc(value) : value;
  };

  render() {
    const { contractVehicle, employeeBranchOrgUnitId } = this.props;
    const { vehicle } = contractVehicle || {};
    const vehicleId = parseInt(this.props.vehicleId, 10);
    return (
      <>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              {vehicle ?
            <>
                  <Crumb to={`/vehicles/contract/${vehicle.id}`}>
                    {vehicle.vehicleModel &&
                `${vehicleTypes[vehicle.vehicleModel.type]} ${
                vehicle.vehicleModel.brandName} ${
                vehicle.vehicleModel.name}`}
                    , {vehicle.yearIssued} ({vehicle.licensePlate})
                  </Crumb>
                  <Crumb to={`/vehicles/contract/edit/${vehicle.id}`}>
                    Редактирование
                  </Crumb>
                </> :

            <Crumb to="/vehicles/contract/new">
                  Новое наемное транспортное средство
                </Crumb>
            }
            </Breadcrumbs>
          } />

        <StyledPanel>
          <h1>
            {contractVehicle ?
            `Транспорт №${contractVehicle.id}` :
            'Новый наемный транспорт'}
          </h1>
        </StyledPanel>
        <InnerForm
          vehicle={contractVehicle || initialContractVehicle}
          employeeBranchOrgUnitId={employeeBranchOrgUnitId}
          onSubmit={async (values) => {
            try {
              notificationLoading({
                message: 'Сохранение данных...',
                key: 'saving'
              });
              if (values.id) {
                await this.props.updateContractVehicle({
                  ...values,
                  vehicle: {
                    ...values.vehicle,
                    status: vehicleStatusEnum.draft
                  }
                });
              } else {
                values.vehicle = {
                  ...values.vehicle,
                  ownerType: ownerTypes.contract
                };
                await this.props.addContractVehicle(values);
              }
              notification.success({
                message: 'Успешно сохранено',
                description: 'Изменения успешно сохранены'
              });
              navigate(`/vehicles/contract/${this.props.contractVehicle.id}`);
            } catch (error) {
              notification.error({
                message: 'Ошибка',
                description: error.message
              });
            } finally {
              notification.destroy('saving');
            }
          }}
          onCancel={() =>
          vehicleId ?
          navigate(`/vehicles/contract/${vehicleId}`) :
          navigate('/vehicles/contract')
          }
          formatDate={this.formatDate}
          changeDate={formatDateTimeToISOString} />

      </>);

  }
}

export default connect(
  (state, props) => ({
    contractVehicle: state.contractVehicle,
    vehicleId: parseInt(props.vehicleId, 10),
    employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
  }),
  {
    updateContractVehicle,
    fetchContractVehicle,
    cleanContractVehicle,
    addContractVehicle
  }
)(Form);
